import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useT } from "@/i18n/LangContext";

export default function MarqueeRibbon() {
  const t = useT();

  return (
    <section
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-lavline py-8 md:py-10"
    >
      <Marquee speed={18} gradient={false} pauseOnHover>
        {t.marquee.map((term) => (
          <span key={term} className="flex items-center">
            <span className="mx-8 font-serif text-3xl italic tracking-tight text-ink/85 md:mx-12 md:text-5xl">
              {term}
            </span>
            <Asterisk className="h-7 w-7 text-bee md:h-9 md:w-9" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
